import { render, staticRenderFns } from "./ContractTplDev.vue?vue&type=template&id=2bfa50a4&scoped=true"
import script from "./ContractTplDev.vue?vue&type=script&lang=js"
export * from "./ContractTplDev.vue?vue&type=script&lang=js"
import style0 from "./ContractTplDev.vue?vue&type=style&index=0&id=2bfa50a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfa50a4",
  null
  
)

export default component.exports